import moment from 'moment';

class TeamCalendarMobileController {
  constructor($window,
              vacationUserDataService,
              vacationDelegationService,
              inceptionService,
              teamCalendarService,
              HelperDelegationsService,
              loadingMobileService,
              metricsService) {
    'ngInject';

    this.vacationUserDataService = vacationUserDataService;
    this.vacationDelegationService = vacationDelegationService;
    this.inceptionService = inceptionService;
    this.teamCalendarService = teamCalendarService;
    this.helperDelegationsService = HelperDelegationsService;
    this.loadingMobileService = loadingMobileService;
    this.metricsService = metricsService;

    this.year = new Date().getFullYear();
    this.isMobileApp = $window.innerWidth < 1024;
    this.managerId = vacationUserDataService.getEmployee().userId;
  }

  $onInit() {
    this._initData();
    this._getDelegations();
  }

  _initData() {
    this.loadingMobileService.show();

    this.loaded = false;
    this.employeeFilters = [];
    this.userId = this.vacationUserDataService.getEmployee().userId;

    this.teamCalendarService.initData(this.userId, this.year)
      .then(({
              rawEmployeeList,
              employeeList,
              employeesForSearch,
              hasDelegated,
              delegation
            }) => {
        this.rawEmployeeList = rawEmployeeList;
        this.employeeList = employeeList;
        this.teamCalendarService.formatEmployeeList(this.employeeList);
        this.employeesForSearch = employeesForSearch;
        this.hasDelegated = hasDelegated;
        this.delegation = delegation;
        this.loaded = true;

        this.metricsService.trackNavigationVacationsAbsencesTeamCalendar();
      }).finally(() => this.loadingMobileService.hide());
  }

  onSearch() {
    return this.helperDelegationsService.onSearchEmployeeDelegations(this.employeesForSearch);
  }

  onSelectEmployee($event) {
    const alreadyInFilters = this.employeeFilters.find(employee => {
      employee.userId === $event.userId;
    });

    if (!alreadyInFilters) {
      this.employeeFilters.push($event);
      this._initTeamCalendarList();
    }
  }

  onCleanEmployeeFilters() {
    this.employeeFilters = [];
    this._initTeamCalendarList();
  }

  onChangeMonth($event) {
    this.teamCalendarDate = $event;
    this._initTeamCalendarList();
  }

  isDisabled() {
    return this.isWageInProcess;
  }

  _getDelegations() {
    const today = moment().format('YYYY-MM-DD');
    return this.vacationDelegationService.hasDelegated(this.managerId).then(response => {
      this.hasDelegated = response.hasDelegated;
      if (this.hasDelegated) {
        this.delegation = this.vacationDelegationService.findDelegationActive(today, response.delegations);
      }
    });
  }

  _initTeamCalendarList() {
    this.teamCalendarList = this.teamCalendarService.getTeamCalendarList(
      this.employeeList,
      this.teamCalendarDate,
      this.employeeFilters
    );
  }
}

export default TeamCalendarMobileController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarMobile.controller.js